export default {
  height: '78px',
  display: 'flex',
  alignItems: 'center',
  boxShadow: '0 2px 10px rgba(45, 49, 50, 0.2)',
  borderRadius: '4px',
};
